import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import playerImg from '@assets/images/placeholder/playerPagePlaceholder.svg'
import CustomLink from '@shared/components/customLink'
import MyImage from '@shared/components/myImage'
import TeamPlaceholder from '@assets/images/placeholder/team-placeholder.svg'

const TrendingPlayerCard = ({ data }) => {
  return (
    <>
      {data?.oPlayer?.oSeo?.sSlug ? (
        <CustomLink href={`/${data?.oPlayer?.oSeo?.sSlug}`} prefetch={false}>
          <a className={`${styles.playerCard} common-box text-center me-auto ms-auto mr-1`}>
            <div className={`${styles.imgBlock} d-block m-auto`}>
              <MyImage
                src={data?.oPlayer?.oImg?.sUrl ? `${S3_PREFIX}${data?.oPlayer?.oImg?.sUrl}` : playerImg}
                width="162"
                height="162"
                alt={data?.oPlayer?.oImg?.sText || `${data?.oPlayer?.sFullName || 'Player'} Image`}
                layout="responsive"
                errorImage={playerImg}
              />
            </div>
            <h3 className={`small-head white-text-color ${styles.name}`}>
              <div className={`${styles.playerName}`}>{data?.oPlayer?.sFullName}</div>
              <div className="d-flex align-item-center justify-content-center">
                <div className={`${styles.teamLogo}`}>
                  <MyImage
                    src={data?.oPlayer?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${data?.oPlayer?.oTeam?.oImg?.sUrl}` : playerImg}
                    width="12"
                    height="12"
                    alt={data?.oPlayer?.oTeam?.oImg?.sText || 'Team Image'}
                    layout="responsive"
                    errorImage={TeamPlaceholder}
                  />
                </div>
                <div className={`${styles.teamName}`}>{data?.oPlayer?.sCountryFull}</div>
              </div>
            </h3>
          </a>
        </CustomLink>
      ) : (
        <>
          <div className={`${styles.playerCard} common-box text-center me-auto ms-auto mr-1`}>
            <div className={`${styles.imgBlock} d-block m-auto`}>
              <MyImage
                src={data?.oPlayer?.oImg?.sUrl ? `${S3_PREFIX}${data?.oPlayer?.oImg?.sUrl}` : playerImg}
                width="162"
                height="162"
                alt={data?.oPlayer?.oImg?.sText || 'Player Image'}
                layout="responsive"
              />
            </div>
            <h3 className={`small-head white-text-color ${styles.name}`}>
              <div className={`${styles.playerName}`}>{data?.oPlayer?.sFullName}</div>
              <div className="d-flex align-item-center justify-content-center">
                <div className={`${styles.teamLogo}`}>
                  <MyImage
                    src={data?.oPlayer?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${data?.oPlayer?.oTeam?.oImg?.sUrl}` : playerImg}
                    width="162"
                    height="162"
                    alt={data?.oPlayer?.oTeam?.oImg?.sText || 'Team Image'}
                    layout="responsive"
                  />
                </div>
                <div className={`${styles.teamName}`}>{data?.oPlayer?.sCountryFull}</div>
              </div>
            </h3>
          </div>
        </>
      )}
    </>
  )
}
TrendingPlayerCard.propTypes = {
  data: PropTypes.object
}

export default TrendingPlayerCard
